import axiosClient from './axiosClient';

export const sourcesApi = {
  list: async (params = {}) => {
    const { data } = await axiosClient.get('/sources', { params });
    return data.data;
  },

  get: async (id) => {
    const { data } = await axiosClient.get(`/sources/${id}`);
    return data.data;
  },

  create: async (payload) => {
    const { data } = await axiosClient.post('/admin/sources', payload);
    return data.data;
  },

  update: async (id, payload) => {
    const { data } = await axiosClient.put(`/admin/sources/${id}`, payload);
    return data.data;
  },

  destroy: async (id) => {
    const { data } = await axiosClient.delete(`/admin/sources/${id}`);
    return data.data;
  },
};